import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import YoutubeEmbed from './YoutubeEmbed'

export default function VideoReviews({ reviews }) {
    const settings = {
        dots: false,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 768, // Adjust this value based on your needs
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    }
    return (
        <Slider {...settings}>
            {reviews &&
                reviews
                    .filter((r) => r.type === 'Video')
                    .map((review, index) => (
                        <div key={index} className="px-2">
                            <div className="bg-olm-gradient-b-to-t p-[1px] rounded-xl">
                                <div className="flex flex-col overflow-hidden">
                                    <YoutubeEmbed
                                        cssClass={'rounded-xl'}
                                        url={review.video}
                                    />
                                </div>
                                {/* <div className="text-left p-6 space-y-3 text-white">
                                    {review.client.name && (
                                        <h3 className="font-semibold text-xl text-white leading-6">
                                            {review.client.name}
                                        </h3>
                                    )}
                                    {review.text && (
                                        <p className="text-base leading-[22px] font-normal overflow-hidden truncate-lines">
                                            {review.text}
                                        </p>
                                    )}
                                    {review.video && (
                                        <a
                                            href={review.video}
                                            target="_blank"
                                            className="inline-block text-base leading-6 font-bold underline"
                                            rel="noreferrer">
                                            Watch Video
                                        </a>
                                    )}
                                </div> */}
                            </div>
                        </div>
                    ))}
        </Slider>
    )
}
